/* global System */

export default {
  TestimonialsSlider: () =>
    System.import(/* webpackChunkName: "TestimonialsSlider" */ './index'),
}
